<template>
  <div id="app">
    <v-app>
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
          <v-container style="margin-top: -5px">
            <v-layout align-center justify-center height="52px">
              <v-flex shrink>
                <span
                  style="
                    font-family: Fredoka One;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 43px;
                    line-height: 52px;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    color: #18739d;
                    flex: none;
                    order: 3;
                    flex-grow: 0;
                    margin: 0px 0px;
                  "
                >
                  Face Similarity
                </span>
              </v-flex>
            </v-layout>
            <p class="subheading" style="text-align: center; margin-top: 1%">
              A demonstration of Privately's technology comparing two images to determine if they come from the same
              person.
            </p>
            <p class="subheading" style="text-align: center">
              Please provide image samples either through your Camera, from files on your computer or a choice of our
              samples provided below and press SUBMIT. For more information on how we process data, please refer to
              <a href="https://www.privately.eu/legal" target="_blank">our privacy policy </a>
            </p>
          </v-container>
          <v-container fluid fill-height style="margin-top: -50px">
            <v-layout row wrap>
              <v-flex xs12 sm6 md6 lg6 xl6>
                <v-container fluid fill-height>
                  <v-layout class="align-center justify-center">
                    <div style="text-align: center">
                      <span class="title custom-text">Select Person #1 </span>
                      <p class="title custom-text" style="margin-top: 5px">
                        <span style="font-size: 30px">&#8681;</span>
                      </p>
                      <v-card
                        height="55"
                        elevation="0"
                        class="d-flex align-center justify-center"
                        color="#eeeeee"
                        style="border-radius: 10px"
                      >
                        <v-select
                          style="margin-top: 5px; width: 10px"
                          :items="images1"
                          label="Choose a preloaded image"
                          @change="readimage(1, $event)"
                        >
                        </v-select>
                      </v-card>
                      <v-card class="d-flex align-center justify-center" elevation="0" color="transparent">
                        <p class="custom-text">OR</p>
                      </v-card>

                      <v-card
                        elevation="0"
                        height="55"
                        class="d-flex align-center justify-center"
                        color="#eeeeee"
                        style="border-radius: 10px"
                      >
                        <div class="file-upload">
                          <input
                            style="width: 300px"
                            class="form-control"
                            @change="customimage('formFile1', 1)"
                            type="file"
                            accept="image/*"
                            id="formFile1"
                          />
                        </div>
                      </v-card>
                      <v-card class="d-flex align-center justify-center" elevation="0" color="transparent">
                        <p class="custom-text">OR</p>
                      </v-card>

                      <v-card
                        height="50"
                        elevation="0"
                        class="d-flex align-center justify-center"
                        color="#18739d"
                        style="border-radius: 10px"
                      >
                        <button
                          type="button"
                          class="button is-rounded"
                          style="color: white; border-radius: 15px"
                          :class="{ 'is-primary': !isCameraOpen, 'is-danger': isCameraOpen }"
                          @click="toggleCamera('1')"
                        >
                          <span v-if="!isCameraOpen" style="font-size: 16px">Open Camera</span>
                          <span v-else style="font-size: 16px">Close Camera</span>
                        </button>
                        <div id="myModal" class="modal">
                          <!-- Modal content -->
                          <div class="modal-content">
                            <span class="close" @click="toggleCamera('1')">&times;</span>
                            <span class="title custom-text" style="top: 40%"
                              >Please press camera button below to take a Snapshot and then press
                              <b>load image</b></span
                            >

                            <div class="web-camera-container">
                              <!-- <div class="camera-button">
                                        <button type="button" class="button is-rounded" 
                                        :class="{ 'is-primary' : !isCameraOpen, 'is-danger' 
                                        : isCameraOpen}" @click="toggleCamera('1')">
                                            <span v-if="!isCameraOpen">Open Camera</span>
                                            <span v-else>Close Camera</span>
                                        </button>
                                    </div> -->

                              <div v-show="isCameraOpen && isLoading" class="camera-loading">
                                <ul class="loader-circle">
                                  <li></li>
                                  <li></li>
                                  <li></li>
                                </ul>
                              </div>

                              <div
                                v-if="isCameraOpen"
                                v-show="!isLoading"
                                class="camera-box"
                                :class="{ flash: isShotPhoto }"
                              >
                                <div class="camera-shutter" :class="{ flash: isShotPhoto }"></div>
                                <video
                                  v-show="!isPhotoTaken"
                                  ref="camera"
                                  :width="450"
                                  :height="337.5"
                                  autoplay
                                ></video>
                                <canvas
                                  v-show="isPhotoTaken"
                                  id="photoTaken"
                                  ref="canvas"
                                  :width="450"
                                  :height="337.5"
                                ></canvas>
                              </div>

                              <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
                                <button type="button" class="button" @click="takePhoto('1')">
                                  <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png" />
                                </button>
                              </div>

                              <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
                                <!-- <button id="downloadPhoto" download="my-photo.jpg" class="button" 
                                        role="button" @click="downloadImage('1')">
                                        Load Image
                                        </button> -->
                                <v-btn
                                  large
                                  @click="downloadImage(camera_number)"
                                  elevation="2"
                                  depressed
                                  color="#18739d"
                                  style="color: white; border-radius: 15px"
                                  >Load Image</v-btn
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-card>

                      <div class="speaker-1 text-center" style="text-align: center">
                        <v-subheader id="img1txt" style="text-align: center">Person 1 :</v-subheader>

                        <!-- <v-img id="img1src" :src="require(`../../assets/images/face_match/Howard-1.jpg`)" 
                        aspect-ratio="1" max-width="50%"></v-img> -->
                        <img
                          id="img1src"
                          class="imagedisplay"
                          alt="Please select person #1"
                          src="../../assets/images/face_match/placeholder1.png"
                        />
                      </div>
                    </div>
                  </v-layout>
                </v-container>
              </v-flex>

              <v-flex xs12 sm6 md6 lg6 xl6>
                <v-container fluid fill-height>
                  <v-layout class="align-center justify-center">
                    <div style="text-align: center">
                      <span class="title custom-text">Select Person #2 </span>
                      <p class="title custom-text" style="margin-top: 5px">
                        <span style="font-size: 30px">&#8681;</span>
                      </p>
                      <v-card
                        height="55"
                        elevation="0"
                        class="d-flex align-center justify-center"
                        color="#eeeeee"
                        style="border-radius: 10px"
                      >
                        <v-select
                          style="margin-top: 5px; width: 10px"
                          :items="images2"
                          label="Choose a preloaded image"
                          @change="readimage(2, $event)"
                        >
                        </v-select>
                      </v-card>
                      <v-card class="d-flex align-center justify-center" elevation="0" color="transparent">
                        <p class="custom-text">OR</p>
                      </v-card>

                      <v-card
                        height="55"
                        elevation="0"
                        class="d-flex align-center justify-center"
                        color="#eeeeee"
                        style="border-radius: 10px"
                      >
                        <div class="file-upload">
                          <input
                            style="width: 300px"
                            class="form-control"
                            @change="customimage('formFile2', 2)"
                            type="file"
                            accept="image/*"
                            id="formFile2"
                          />
                        </div>
                      </v-card>
                      <v-card class="d-flex align-center justify-center" elevation="0" color="transparent">
                        <p class="custom-text">OR</p>
                      </v-card>

                      <v-card
                        height="50"
                        elevation="0"
                        class="d-flex align-center justify-center"
                        color="#18739d"
                        style="border-radius: 10px"
                      >
                        <button
                          type="button"
                          class="button is-rounded"
                          style="color: white; border-radius: 15px"
                          :class="{ 'is-primary': !isCameraOpen, 'is-danger': isCameraOpen }"
                          @click="toggleCamera('2')"
                        >
                          <span v-if="!isCameraOpen" style="font-size: 16px">Open Camera</span>
                          <span v-else style="font-size: 16px">Close Camera</span>
                        </button>
                      </v-card>
                      <div class="speaker-1 text-center" style="text-align: center">
                        <v-subheader id="img2txt" style="text-align: center">Person 2 :</v-subheader>
                        <img
                          id="img2src"
                          class="imagedisplay"
                          alt="Please select person #2"
                          src="../../assets/images/face_match/placeholder2.png"
                        />
                      </div>
                    </div>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container fluid fill-height>
            <v-layout row wrap class="align-center justify-center">
              <v-flex xs12 sm6 md3 xl3 lg3>
                <div>
                  <v-btn
                    large
                    @click="getprediction()"
                    elevation="2"
                    depressed
                    color="#18739d"
                    style="color: white; border-radius: 15px"
                    >Submit</v-btn
                  >
                </div>
              </v-flex>
              <v-flex xs12 sm6 md3 xl3 lg4>
                <h2 style="text-align: center">Face Matching Result:</h2>
                <h1 v-if="!loading" :class="predictioncl" id="prediction" style="text-align: center; margin-top: 5%">
                  {{ predictionResult }}
                </h1>
                <h2 v-if="!loading" :class="predictioncl" id="score" style="text-align: center; margin-top: 5%">
                  {{ predictionScore }}
                </h2>

                <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-container>
    </v-app>
  </div>
</template>


<script>
import axios from "axios";

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.withCredentials = false;

// console.log("landed!");
var modal = document.getElementById("myModal");
window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
};

export default {
  name: "FaceVerify",
  data() {
    return {
      loading: false,
      predictioncl: "",
      predictionResult: "--",
      predictionScore: "",
      image_folder: "../../assets/images/face_match/",
      images1: ["sheldon-1.jpeg", "Howard-1.jpeg", "Penny-1.png"],
      images2: ["sheldon-2.jpeg", "Howard-2.jpg", "Penny-2.jpeg"],
      api_url: "https://showroom.privately.swiss:8081",
      // api_url:"http://127.0.0.1:8082/",
      progressValue: 0,
      processingDone1: false,
      processingDone2: false,
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      camera_number: "",
    };
  },
  methods: {
    popupOpen() {
      var modal = document.getElementById("myModal");
      modal.style.display = "block";
    },
    popupclose() {
      var modal = document.getElementById("myModal");
      modal.style.display = "none";
    },
    toggleCamera(speaker_no) {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.camera_number = "";
        this.stopCameraStream();
        this.popupclose();
      } else {
        this.isCameraOpen = true;
        this.camera_number = speaker_no;
        this.createCameraElement();
        this.popupOpen();
      }
    },
    createCameraElement() {
      this.isLoading = true;

      const constraints = (window.constraints = {
        audio: false,
        video: true,
      });

      console.log(this.$refs);
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
          // if (speaker_no == "1"){
          // 	this.$refs.camera.srcObject = stream;}
          // else{
          // 	this.$refs.camera.srcObject = stream;
          // }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("May the browser didn't support or there is some errors.");
        });
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();
      // if (speaker_no == "1"){
      // 	let tracks = this.$refs.camera.srcObject.getTracks();
      // }
      // else{
      // 	let tracks = this.$refs.camera.srcObject.getTracks();
      // }

      tracks.forEach((track) => {
        track.stop();
      });
    },

    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;
      const context = this.$refs.canvas.getContext("2d");
      //   if (speaker_no == "1"){
      //   	const context = this.$refs.canvas.getContext('2d');
      //   }
      //   else{
      // 	const context = this.$refs.canvas.getContext('2d');
      //   }
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
    },
    downloadImage(speaker_no) {
      // const download = document.getElementById("downloadPhoto");
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg");
      //   console.log(canvas)
      document.getElementById("img" + speaker_no + "src").src = canvas;
      this.resetpredictionlabel();
      this.toggleCamera(speaker_no);
    },
    readimage(speaker_no, im_name) {
      const options = {
        url: this.api_url + "/showroom/facesamples",
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {
          img_name: im_name,
        },
      };
      axios(options)
        .then((res) => {
          document.getElementById("img" + speaker_no + "src").src = "data:image/jpg;base64," + res.data["img_base64"];
          document.getElementById("img" + speaker_no + "txt").innerHTML = "Person " + speaker_no + " : " + im_name;
          this.resetpredictionlabel();
        })
        .catch((err) => console.log("Image fetching error occurred:" + err));
    },
    customimage(form_id, speaker_no) {
      this.resetpredictionlabel();

      // console.log(document.getElementById(form_id).files[0]);
      var file = document.getElementById(form_id).files[0];

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        var base64data1 = reader.result;
        // console.log(base64data1)
        document.getElementById("img" + speaker_no + "src").src = base64data1;
        // document.getElementById('audio1').src = base64data1;
        document.getElementById("img" + speaker_no + "txt").innerHTML = "Person " + speaker_no + " : " + file.name;
        // document.getElementById("form" + speaker_no + "btn").innerHTML = "Selected";
      };
    },
    resetpredictionlabel() {
      this.predictionResult = "--";
      this.predictionScore = " ";
      document.getElementById("prediction").style.color = "#000000";
    },

    getprediction() {
      // console.log("entered prediction");
      // console.log(document.getElementById("audio1src").src);
      if (document.getElementById("img1src").src.length < 100 || document.getElementById("img2src").src.length < 100) {
        alert("Image Files not selected ! Please select both image files");
      } else {
        this.loading = true;
        var data = {
          image1: document.getElementById("img1src").src.slice(22),
          image2: document.getElementById("img2src").src.slice(22),
        };
        // console.log(data);
        // Storing response
        const options = {
          url: this.api_url + "/showroom/faceverify",
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: data,
        };
        axios(options)
          .then((res) => {
            this.loading = false;
            console.log(res.data);
            if (res.data["prediction"] == "Matched") {
              this.predictionResult = "Faces Matched !";
              this.predictionScore = "Similarity Score :" + res.data["similarity_score"].toFixed(2);
              this.predictioncl = "match";
            } else if (res.data["prediction"] == "Not matched") {
              this.predictionResult = "Faces did not match !";
              this.predictionScore = "Similarity Score :" + res.data["similarity_score"].toFixed(2);
              this.predictioncl = "nomatch";
            } else if (res.data["error"] == "Face not detected" || res.data["error"] == "Multiple Faces detected") {
              this.predictionResult = "Error: " + res.data["error"];
              this.predictionScore = "Similarity Score :" + res.data["similarity_score"].toFixed(2);
              this.predictioncl = "nomatch";
            } else {
              this.predictionResult = "Error";
              this.predictioncl = "nomatch";
              console.log(res.data["error"]);
            }
          })
          .catch((err) => {
            this.loading = false;
            console.log("The following API prediction error occurred:" + err);
          });
      }
    },
  },
};
</script>
<style scoped>
.imagedisplay {
  width: 200px;
  height: 130px;
  border-width: 1px;
  border-color: #999;
}
.custom-text {
  font-family: Fredoka One;
  font-style: normal;
  font-weight: normal;
  font-size: 23px;
  line-height: 52px;
  text-align: center;
  color: #18739d;
  margin: 0px 0px;
}
.match {
  color: #3cb371;
}
.nomatch {
  color: #ff0000;
}

.person {
  margin-top: 1%;
}
.web-camera-container {
  margin-top: 10%;
  margin-bottom: 2rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border: 1px solid #ccc; */
  border-radius: 4px;
  /* width: 500px; */
}

.web-camera-container .camera-button {
  margin-bottom: 2rem;
}

.web-camera-container .camera-box .camera-shutter {
  opacity: 0;
  width: 450px;
  height: 337.5px;
  background-color: #fff;
  position: absolute;
}
.web-camera-container .camera-box .camera-shutter .flash {
  opacity: 1;
}

.camera-shoot {
  margin: 1rem 0;
}

.camera-shoot button {
  height: 60px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
.camera-shoot img {
  height: 35px;
  object-fit: cover;
}

.camera-loading {
  overflow: hidden;
  height: 100%;
  position: absolute;
  width: 100%;
  min-height: 150px;
  margin: 3rem 0 0 -1.2rem;
}
.camera-loading ul {
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 999999;
  margin: 0;
}

.camera-loading .loader-circle {
  display: block;
  height: 14px;
  margin: 0 auto;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  transform: translateX(-50%);
  position: absolute;
  width: 100%;
  padding: 0;
}
.camera-loading .loader-circle li {
  display: block;
  float: left;
  width: 10px;
  height: 10px;
  line-height: 10px;
  padding: 0;
  position: relative;
  margin: 0 0 0 4px;
  background: #999;
  animation: preload 1s infinite;
  top: -50%;
  border-radius: 100%;
}
.camera-loading .loader-circle li :nth-child(2) {
  animation-delay: 0.2s;
}

.camera-loading .loader-circle li :nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes preload {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>


